import React from 'react';

import { useInitPostHog } from '@/hooks/useInitPostHog.ts';
import { useReleaseNotesBanner } from '@/hooks/useReleaseNotesBanner.ts';
import { AppRouter } from '@/router/AppRouter.tsx';

export const AppReady: React.FC = () => {
  useReleaseNotesBanner();
  useInitPostHog();

  return <AppRouter />;
};
